export class ThemeEvents {
  static discountUpdate = "discount:update";
}

export class DiscountUpdateEvent extends Event {
  constructor(resource, sourceId) {
    super(ThemeEvents.discountUpdate, { bubbles: true });
    this.detail = { resource, sourceId };
  }
}

const callAutoRecalculateShipping = async () => {
  const cartShippingComponent = document.querySelector(
    "cart-shipping-component"
  );

  if (cartShippingComponent?.autoRecalculateShipping) {
    cartShippingComponent.autoRecalculateShipping();
    return;
  }

  if (typeof customElements?.whenDefined === "function") {
    await customElements.whenDefined("cart-shipping-component");
    const upgradedComponent = document.querySelector("cart-shipping-component");
    upgradedComponent?.autoRecalculateShipping?.();
  }
};

// A limpeza do localStorage saiu daqui: quem apaga as taxas e o proprio
// componente, dentro de invalidateShipping, no mesmo passo em que limpa a
// tela e reconsulta. Apagar antes de chamar deixava o componente sem saber
// que havia um calculo valido para invalidar - ele desistia e as taxas
// obsoletas continuavam visiveis.
document.addEventListener("cart-update", () => {
  callAutoRecalculateShipping();
});

// Cupom aplicado/removido muda o valor do pedido, que e uma das entradas do
// calculo de frete (frete gratis acima de X, por exemplo).
document.addEventListener("discount:update", () => {
  callAutoRecalculateShipping();
});
